module.exports = __webpack_public_path__ + "static/media/bottom_banner_2_2.d6c92b5f.png";